
















import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import applicationBar from './components/layout/ApplicationBar.vue';
import applicationMessage from './components/layout/ApplicationMessage.vue';
import applicationFooter from './components/layout/ApplicationFooter.vue';

export default Vue.extend({
    name: 'App',
    components: {
        applicationBar,
        applicationMessage,
        applicationFooter,
    },
    computed: {
        ...mapState(['working']),
        ...mapGetters(['isAuthenticated']),
    },
});
